module.exports = __webpack_public_path__ + "static/12-879d3932a79eefd90b35e0699dc10330.png";